import { defineMessages } from 'react-intl';

export default defineMessages({
  available: {
    defaultMessage: 'Available at {store}',
    description:
      'Message alerting the customer that this product is available at the selected store.',
    id: 'ordering.productPage.available',
  },
  notOrderable: {
    defaultMessage: 'Unavailable to purchase online',
    description:
      'Message alerting the customer that this product cannot be purchased online.',
    id: 'ordering.productPage.notOrderable',
  },
  selectStoreForAvailability: {
    defaultMessage: 'Select a store to view availability',
    description:
      'Message asking the customer to select a store to see product availability.',
    id: 'ordering.productPage.selectStoreForAvailability',
  },
  temporarilyUnavailable: {
    defaultMessage: 'Sold out at {store}',
    description:
      'Message alerting the customer that this product is sold out at the selected store.',
    id: 'ordering.productPage.temporarilyUnavailable',
  },
  unavailable: {
    defaultMessage: 'This item is unavailable',
    description:
      'Message alerting the customer that this product is currently unavailable.',
    id: 'ordering.productPage.unavailable',
  },
  unavailableHere: {
    defaultMessage: 'Not sold at {store}',
    description:
      'Message alerting the customer that this product is not sold at the selected store.',
    id: 'ordering.productPage.unavailableHere',
  },
});
